<template>
    <div class="cabinet-menu" v-bind:class="themeClass">
        <div class="cabinet-menu__description">
            <img class="cabinet-menu__description--floor" :src="sexImage" alt="" />
            <div class="cabinet-menu__description--info">
                <div class="cabinet-menu__description--name">{{userName | Capitalized}}</div>
                <div class="cabinet-menu__description--exit" @click="logout">Выход</div>
            </div>
        </div>
        <nav class="cabinet-menu__wrap">
            <ul class="cabinet-menu__list">
                <router-link class="cabinet-menu__item"
                     v-for="item in itemsMenu"
                     v-bind:class="'cabinet-menu__item--'+item.className"
                     v-html="item.text"
                     :key="item.id"
                     :to="{ name: item.name }"
                     v-if="item.show()"
                >
                </router-link>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    name: "CabinetMenu",
	props: {
		theme: {
			default: 'light'
		},
	},
    data(){
        return {
            itemsMenu: [
                {
                    name: 'CabinetIndex',
                    className: 'cabinet-index',
                    text: 'Главная',
                    show: () => {
                        return true;
                    }
                },
                {
                    name: 'CurrentLoan',
                    className: 'current-loan',
                    text: 'Текущий микрокредит',
                    show: () => {
                        return this.$store.getters['current/getCurrentLoan'].documentNumber !== '';
                    }
                },
                {
                    name: 'LoanHistory',
	                className: 'loan-history',
                    text: 'История',
                    show: () => {
                        return this.haveHistory;
                    }
                },
            ],

            haveHistory: false,
        }
    },
    methods: {
        logout: function () {
            let _this = this;
            this.$http.get( this.$http.defaults.baseURL.replace('api','logout') ).then(
                (response) => {
                    if(response.status === 200){
                        _this.$router.push({name: 'Index'});
                        window.location.reload();
                    }
                },
                (response) => {

                }
            )
        }
    },
	computed: {
	    isDarkTheme(){
		    return this.theme === 'dark';
	    },
	    isLightTheme(){
		    return this.theme === 'light';
	    },
		themeClass(){
			return {
				'cabinet-menu--dark': this.isDarkTheme,
				'cabinet-menu--light': this.isLightTheme
			}
		},
        userName() {
            return this.$store.getters['profile/getField']('firstName');
        },
        userSex() {
            return this.$store.getters['profile/getField']('sex');
        },
        sexImage(){
	        switch (this.userSex){
                case 'MALE': {
                    return require('@/assets/svg/icons/icon_signin_man.svg');
                    break
                }
                case 'FEMALE': {
                    return require('@/assets/svg/icons/icon_signin_woman.svg');
                    break
                }
                default: {
                    return require('@/assets/svg/icons/icon_signin_nosex.svg');
                    break;
                }
            }
        },
    },
    mounted(){
        let _this = this;
        if( !this.$store.getters['profile/isInited'] ){
            this.$store.dispatch('profile/INIT');
        }
        this.$http.get('/json/credit?issued=true').then(
            (response) => {
                if (response.data.code === 0) {
                    _this.haveHistory = response.data.data.length > 0;
                }
            },
            (response) => {

        });
    }
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.cabinet-menu {
    $blockname: &;

    display: inline-flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: flex-start;
    max-width: 320px;
    width: 100%;
    margin: 0;
    padding: 10px 10px 30px;

    &__description {
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-start;

        width: 100%;
        margin-bottom: 31px;
    }
    &__description--floor {
        width: 50px;
        height: 50px;
        margin: 0 13px 0 10px;
    }
    &__description--info {
        display: inline-flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: flex-start;
    }
    &__description--name {
        color: $yellow-site;
        text-align: left;
        font-family: $RobotoBold;
        font-size: 18px;
    }
    &__description--exit {
        color: $gray-dim;
        text-align: left;
        font-family: $RobotoRegular;
        font-size: 16px;
        &:hover{
            cursor: pointer;
            color: $purple-site;
            text-decoration: underline;
        }
    }

    &__wrap {
        width: 100%;
    }
    &__list {}
    &__item {
        position: relative;
        display: inline-flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-start;

        width: 100%;
        min-height: 44px;
        padding: 0 10px;
        border-top: 1px solid $gray-mint;
        list-style: none;
        text-decoration: none;

        color: $gray-dim-dark;
        font-size: 18px;
        font-family: $RobotoRegular;

        &.router-link-active {
            background: $purple-site-o-2;
            .questions-answers__item-description {
                color: $purple-site;
            }
        }
    }
    &__item:last-child {
        border-bottom: 1px solid $gray-mint;
    }

    &--light {
        background: $white;
    }
    &--dark {
        background: $gray-dim-dark;
        #{$blockname}__description {
            &--exit {
                color: #DCDCDC;
            }
        }
        #{$blockname}__item {
            color: #DCDCDC;
            border-color: #646464;
            &.router-link-active {
                background: #531651;
                color: $white;
            }
        }
    }
}
</style>
